var path = 'src/app/components/customer/credit-scoring/credit-scoring-modal-features.template.html';
var html = "<canvas id=\"{{$ctrl.featureName}}\"></canvas>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;